import { render, staticRenderFns } from "./ItemManagementPage.vue?vue&type=template&id=170cf117&scoped=true&"
import script from "./ItemManagementPage.vue?vue&type=script&lang=ts&"
export * from "./ItemManagementPage.vue?vue&type=script&lang=ts&"
import style0 from "./ItemManagementPage.vue?vue&type=style&index=0&id=170cf117&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170cf117",
  null
  
)

export default component.exports